export default __webpack_public_path__ + "ui/assets/img/roaming-green-24.svg";